/**
 * OS のファイルドラッグかどうかを判定する。アプリ内のドラッグは独自 MIME
 * (application/x-izanagi-dnd) のみを載せ "Files" を含まないため、これで自然に区別できる。
 */
export function isFileDrag(e: React.DragEvent): boolean {
	return e.dataTransfer.types.includes("Files");
}
